export default {"src":"/_next/static/media/trophy-illustration.49ea8aa0.svg","height":571,"width":570,"blurWidth":0,"blurHeight":0};